import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Clock, ShoppingCart, Activity, ShieldAlert, CheckCircle2 } from 'lucide-react';
const items = [{
  icon: <BookOpen className="w-6 h-6 text-brand-orange" data-id="element-14" />,
  title: "La Guía Maestra 'El Código de Insulina 55+'",
  desc: 'El manual completo en formato PDF con toda la ciencia explicada de forma sencilla.'
}, {
  icon: <Clock className="w-6 h-6 text-brand-orange" data-id="element-15" />,
  title: 'El Protocolo de Reseteo de 48 Horas',
  desc: 'Plan de acción exacto para bajar la glucosa en tiempo récord.'
}, {
  icon: <ShoppingCart className="w-6 h-6 text-brand-orange" data-id="element-16" />,
  title: 'Lista de Compras Anti-Insulina',
  desc: 'Qué comprar exactamente en el supermercado sin perder tiempo.'
}, {
  icon: <Activity className="w-6 h-6 text-brand-orange" data-id="element-17" />,
  title: 'El Rastreador de Glucosa Crítica Post-Comida',
  desc: 'Herramienta para identificar tus saboteadores personales.'
}, {
  icon: <ShieldAlert className="w-6 h-6 text-brand-orange" data-id="element-18" />,
  title: "Cheat Sheet: 'Los 5 Saboteadores Ocultos'",
  desc: 'Identifica los enemigos metabólicos que están en tu cocina ahora mismo.'
}];
export function Deliverables() {
  return <section className="py-20 px-4 bg-navy-900 border-t border-navy-800" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-21">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-22">
            Lo que obtienes hoy
          </h2>
          <p className="text-xl text-gray-400" data-id="element-23">
            Un sistema completo, sin relleno. Solo lo que necesitas para ver
            resultados.
          </p>
        </motion.div>

        <div className="bg-navy-800 rounded-3xl p-8 md:p-12 border border-navy-700 shadow-2xl" data-id="element-24">
          <div className="space-y-6" data-id="element-25">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start space-x-4 p-4 rounded-xl hover:bg-navy-900/50 transition-colors border border-transparent hover:border-navy-700" data-id="element-26">
                <div className="bg-navy-900 p-3 rounded-lg shrink-0 border border-navy-700" data-id="element-27">
                  {item.icon}
                </div>
                <div data-id="element-28">
                  <h3 className="text-xl font-bold text-white mb-1 flex items-center" data-id="element-29">
                    {item.title}
                    <CheckCircle2 className="w-5 h-5 text-green-500 ml-2 hidden md:inline-block" data-id="element-30" />
                  </h3>
                  <p className="text-gray-400" data-id="element-31">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}